import React from 'react';
import { BrowserRouter, BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './router';
import Demo from './DashboardLayout';
import DashboardLayout from './DashboardLayout';
import { createTheme, ThemeProvider } from '@mui/material';
import GoogleLoginHandler from './GoogleLoginHandler';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './AuthContext';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import { HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'; // para date-fns

const App: React.FC = () => {
    const theme = createTheme(); // Define el tema
    const GOOGLE_CLIENT_ID = "174285649504-c9avu6sdn8klct6o8ggnlar6esimd5ah.apps.googleusercontent.com";

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>

    <ThemeProvider theme={theme}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>    <HelmetProvider>

    <Router>
      <DashboardLayout />
      </Router>
      </HelmetProvider>

      </AuthProvider>
      </GoogleOAuthProvider>
      <PWAInstallPrompt />

      </ThemeProvider>
      </LocalizationProvider>

  );
};

export default App;